function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 3060");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M81.995 22.66v65.055a4.759 4.759 0 0 1-4.759 4.758h-59.33a4.759 4.759 0 0 1-4.759-4.758V5.133a4.759 4.759 0 0 1 4.76-4.758h41.46L81.995 22.66z",
  fill: "#E2E5E7"
}), React.createElement("path", {
  d: "M63.719 22.66h18.276L59.367.376l.087 18.042a4.264 4.264 0 0 0 4.265 4.244",
  fill: "#B0B7BD"
}), React.createElement("path", {
  fill: "#CAD1D8",
  d: "M63.719 22.66h18.276v18.017z"
}), React.createElement("path", {
  d: "M64.306 77.888H4.836a4.714 4.714 0 0 1-4.713-4.713V48.178a4.714 4.714 0 0 1 4.714-4.713h59.469a4.712 4.712 0 0 1 4.713 4.713v24.997a4.712 4.712 0 0 1-4.713 4.713",
  fill: "#17BFA3"
}), React.createElement("path", {
  d: "M65.631 77.888H13.148v2.391h52.483a3.388 3.388 0 0 0 3.388-3.388v-2.39a3.388 3.388 0 0 1-3.388 3.387",
  fill: "#CAD1D8"
}), React.createElement("text", {
  fontFamily: "proxima-nova",
  fontSize: 13.346,
  fontWeight: 500,
  fill: "#FFF",
  transform: "translate(0 .37)"
}, React.createElement("tspan", {
  x: 21,
  y: 63.63
}, "BED")));

var SvgIconBed = function SvgIconBed(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 93,
    viewBox: "0 0 82 93",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-bed.686d094a.svg";
export { ForwardRef as ReactComponent };